import config from '../config';

import {
  isRoute,
  isRouteIgnored,
  isRouter,
} from '../helpers';

export default function page(...args) {
  let pageRoute;
  if (args.length && isRouter(args[0])) pageRoute = args[0].currentRoute;

  if (args.length && isRoute(args[0])) pageRoute = args[0];

  if (pageRoute) {
    this.trackRoute(pageRoute);
  }
}

export function trackRoute(route) {
  if (isRouteIgnored(route)) return;

  if (!route.name) {
    console.log('Route name is mandatory.');
  }
}

export function autoTracking() {
  const { router, routeTrack } = config;
  if (!router || !Object.prototype.hasOwnProperty.call(routeTrack, 'enable') || !routeTrack.enable) return;

  config.router.afterEach((to, from) => {
    const { skipSamePath } = routeTrack;
    if (skipSamePath && to.path === from.path) return;

    config.$vue.nextTick().then(() => {
      trackRoute(router.currentRoute);
    });
  });
}
